export class HorseOwner {
    id: number;
    name: string;
    emailAddress: string;
    phone: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
}



// WEBPACK FOOTER //
// ./src/model/horseOwner.ts